import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { TrackComponent } from '@eliadmin/core/src/components/analytics/analytics-helpers';
import { ProductCard } from '@eliadmin/core/src/components/product/product-card';
import { ProductListSchema } from '@eliadmin/core/src/components/seo/product-list-schema';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getProductPriceDisplay } from '@eliadmin/core/src/utils/product-price-utils';

export type ProductsGridProps = {
  products: Product[];
  emitSchema?: boolean;
  className?: {
    wrapper?: string;
  };
};
export function ProductsGrid(props: ProductsGridProps) {
  const currency = useGlobalStore(s => s.generalLayout?.currency);
  const schemaCurrency = useGlobalStore(s => s.generalLayout?.currency_code);

  return (
    <>
      {props.emitSchema !== false && (
        <ProductListSchema products={props.products} currency={(schemaCurrency || currency)} />
      )}
      <div
        className={cn(
          'grid w-full grid-cols-2 gap-x-2 gap-y-6 sm:gap-x-4 sm:gap-y-8 md:grid-cols-3 lg:grid-cols-4 lg:gap-x-6 lg:gap-y-12',
          'ea-product-list',
          props.className?.wrapper,
        )}
      >
        <TrackComponent
          eventName={'view_item_list'}
          items={props.products.flatMap(product => {
            const priceDisplay = getProductPriceDisplay(product);
            if (priceDisplay.priceOnRequest || priceDisplay.currentWithVat == null) return [];

            return [
              {
                item_id: product.code,
                item_name: product.name,
                price: priceDisplay.currentWithVat,
                quantity: 1,
              },
            ];
          })}
        />
        {props.products.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </>
  );
}
